import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react'
import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import { useTheme } from '@mui/styles';
import { Avatar, Box, Divider, FormControlLabel, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Toolbar, Tooltip, Typography, CssBaseline, Grid, Badge } from '@mui/material';
import { AccountBalanceWalletOutlined, Assignment, AssignmentIndOutlined, ChevronLeft, ChevronRight, DoneAllOutlined, Home, Logout, MenuOutlined, NotificationsOutlined, Sync } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import SwitchTheme from '../../../components/SwitchTheme';
import { CustomDescrypt } from '../../../utils/MyEncryption';
import { base_url } from '../../../utils/GlobalVariables';
import { NotifStore } from '../../../store/UserStore';
import { getDatabase, ref, remove } from 'firebase/database';

const drawerWidth = 280;
// const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 4,
        top: 8,
        padding: '0 4px',
    },
}));

const NavBd = (props) => {
    const theme = useTheme();
    const location = useLocation();
    const [isOpenState, setIsOpenState] = useState(true);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [anchorElNotif, setAnchorElNotif] = useState(null);
    const [profilPict, setProfilPict] = useState();

    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));

    const pemberitahuans = NotifStore((state) => state.pemberitahuans);
    const resetPemberitahuans = NotifStore((state) => state.resetPemberitahuans);

    useEffect(() => {
        setProfilPict(base_url + '/uploads/images/bendahara/' + decryptedUser.username + '.png')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const toggleDrawer = (state) => {
        setIsOpenState(state);
    };

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleOpenNotif = (event) => {
        setAnchorElNotif(event.currentTarget);
    };

    const handleCloseNotif = () => {
        setAnchorElNotif(null);
        resetPemberitahuans();
        const db = getDatabase();
        remove(ref(db, '/pencairan/' + decryptedUser.id_opd));
    };

    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    }));

    return (
        <>
            <Box sx={{ display: 'flex' }} mb={2}>
                <CssBaseline />
                <AppBar position="fixed" open={isOpenState}>
                    <Toolbar sx={{ background: theme.palette.breadcrumbsBg }}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => toggleDrawer(true)}
                            edge="start"
                            sx={{
                                marginRight: 5,
                                ...(isOpenState && { display: 'none' }),
                            }}
                        >
                            <MenuOutlined />
                        </IconButton>
                        <AccountBalanceWalletOutlined sx={{ display: { xs: 'none', md: 'flex' }, mr: 2 }} />
                        <Typography variant="h6" noWrap component="div">
                            WALLET
                        </Typography>
                        <Box sx={{ flexGrow: 1, bgcolor: "blue" }}>
                        </Box>
                        <Box sx={{ flexGrow: 0 }}>
                            <Grid container spacing={2}>
                                <Grid item>
                                    <Tooltip title="Notifications">
                                        <IconButton onClick={handleOpenNotif} sx={{ p: 0 }}>
                                            <StyledBadge badgeContent={pemberitahuans.length} color="error">
                                                <Avatar alt="Remy Sharp" sx={{ bgcolor: "rgba(92, 37, 141, 0.5)" }} >
                                                    <NotificationsOutlined />
                                                </Avatar>
                                            </StyledBadge>
                                        </IconButton>
                                    </Tooltip>
                                    <Menu
                                        sx={{ mt: '45px' }}
                                        id="menu-appbar"
                                        anchorEl={anchorElNotif}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElNotif)}
                                        onClose={handleCloseNotif}
                                        PaperProps={{
                                            elevation: 0,
                                            sx: {
                                                overflow: 'visible',
                                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                                mt: 1.5,
                                                '& .MuiAvatar-root': {
                                                    width: 32,
                                                    height: 32,
                                                    ml: -0.5,
                                                    mr: 1,
                                                },
                                                '&:before': {
                                                    content: '""',
                                                    display: 'block',
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 14,
                                                    width: 10,
                                                    height: 10,
                                                    bgcolor: 'background.paper',
                                                    transform: 'translateY(-50%) rotate(45deg)',
                                                    zIndex: 0,
                                                }
                                            },
                                        }}
                                    >
                                        {
                                            pemberitahuans.length > 0 ?
                                                pemberitahuans.map((item, index) => (
                                                    <MenuItem key={index}>
                                                        {/* <ListItem alignItems="flex-start"> */}
                                                        <ListItemIcon>
                                                            <Assignment />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary={item.judul}
                                                            secondary={
                                                                <React.Fragment>
                                                                    <Typography
                                                                        sx={{ display: 'inline' }}
                                                                        component="span"
                                                                        variant="body2"
                                                                        color="text.primary"
                                                                    >
                                                                        No. SPM : {item.no_spm}
                                                                    </Typography>
                                                                    {" - " + item.jenis + " — Rp. " + item.anggaran}
                                                                </React.Fragment>
                                                            }
                                                        />
                                                        {/* </ListItem> */}
                                                    </MenuItem>
                                                ))
                                                :
                                                <MenuItem onClick={handleCloseNotif} >
                                                    <ListItemText
                                                        primary="Tidak ada Pemberitahuan"
                                                        secondary={
                                                            <React.Fragment>
                                                                <Typography
                                                                    sx={{ display: 'inline' }}
                                                                    component="span"
                                                                    variant="body2"
                                                                    color="text.primary"
                                                                >

                                                                </Typography>
                                                            </React.Fragment>
                                                        }
                                                    />
                                                    {/* </ListItem> */}
                                                </MenuItem>
                                        }
                                    </Menu>
                                </Grid>
                                <Grid item>
                                    <Tooltip title="Open settings">
                                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                            <Avatar alt="Remy Sharp" sx={{ bgcolor: "rgb(67, 137, 162)" }} src={profilPict} />
                                        </IconButton>
                                    </Tooltip>
                                    <Menu
                                        sx={{ mt: '45px' }}
                                        id="menu-appbar"
                                        anchorEl={anchorElUser}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElUser)}
                                        onClose={handleCloseUserMenu}
                                        PaperProps={{
                                            elevation: 0,
                                            sx: {
                                                overflow: 'visible',
                                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                                mt: 1.5,
                                                '& .MuiAvatar-root': {
                                                    width: 32,
                                                    height: 32,
                                                    ml: -0.5,
                                                    mr: 1,
                                                },
                                                '&:before': {
                                                    content: '""',
                                                    display: 'block',
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 14,
                                                    width: 10,
                                                    height: 10,
                                                    bgcolor: 'background.paper',
                                                    transform: 'translateY(-50%) rotate(45deg)',
                                                    zIndex: 0,
                                                },
                                                width: '20ch',
                                            },
                                        }}
                                    >
                                        <MenuItem onClick={handleCloseUserMenu}>
                                            <Avatar /> Profile
                                        </MenuItem>
                                        <Divider />
                                        <MenuItem>
                                            Theme <FormControlLabel control={<SwitchTheme sx={{ m: 1 }} onChange={() => props.setMode(props.mode === "light" ? "dark" : "light")} checked={props.mode === 'dark' ? true : false} />} label={props.mode === 'dark' ? "Dark" : "Light"}
                                            />
                                        </MenuItem>
                                        <MenuItem onClick={props.onLogOut}>
                                            <ListItemIcon>
                                                <Logout fontSize="small" />
                                            </ListItemIcon>
                                            Logout
                                        </MenuItem>
                                    </Menu>
                                </Grid>
                            </Grid>
                        </Box>
                    </Toolbar>
                </AppBar>
                <Drawer variant="permanent" open={isOpenState}>
                    <DrawerHeader>
                        <IconButton onClick={() => toggleDrawer(false)}>
                            {theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />}
                        </IconButton>
                    </DrawerHeader>
                    <Divider />
                    <List>
                        <Tooltip title="Home" placement="right">
                            <ListItemButton to="/bnd" component={Link} selected={"/bnd" === location.pathname}>
                                <ListItemIcon>
                                    <Home />
                                </ListItemIcon>
                                <ListItemText primary="Home" />
                            </ListItemButton>
                        </Tooltip>
                        <Divider />
                        <Tooltip title="Home" placement="right">
                            <ListItemButton
                                to="/bnd/pencairan"
                                component={Link}
                                selected={
                                    "/bnd/pencairan" === location.pathname ||
                                    "/bnd/pencairan/add" === location.pathname ||
                                    "/bnd/pencairan/edit" === location.pathname
                                }
                            >
                                <ListItemIcon>
                                    <Assignment />
                                </ListItemIcon>
                                <ListItemText primary="Permintaan" />
                            </ListItemButton>
                        </Tooltip>
                        <Tooltip title="Acc" placement="right">
                            <ListItemButton to="/bnd/proses_sp2d" component={Link} selected={"/bnd/proses_sp2d" === location.pathname}>
                                <ListItemIcon>
                                    {<Sync />}
                                </ListItemIcon>
                                <ListItemText primary="Proses SP2d" />
                            </ListItemButton>
                        </Tooltip>
                        <Tooltip title="Selesai" placement="right">
                            <ListItemButton to="/bnd/selesai" component={Link} selected={"/bnd/selesai" === location.pathname}>
                                <ListItemIcon>
                                    {<DoneAllOutlined />}
                                </ListItemIcon>
                                <ListItemText primary="Selesai" />
                            </ListItemButton>
                        </Tooltip>
                        <Divider />
                        <Tooltip title="Kontrak" placement="right">
                            <ListItemButton to="/bnd/kontrak" component={Link}
                                selected={
                                    "/bnd/kontrak" === location.pathname ||
                                    "/bnd/kontrak/add" === location.pathname ||
                                    "/bnd/kontrak/edit" === location.pathname ||
                                    "/bnd/kontrak/detail" === location.pathname ||
                                    "/bnd/kontrak/adendum-add" === location.pathname ||
                                    "/bnd/kontrak/adendum-edit" === location.pathname ||
                                    "/bnd/kontrak/adendum-detail" === location.pathname
                                }
                            >
                                <ListItemIcon>
                                    {<AssignmentIndOutlined />}
                                </ListItemIcon>
                                <ListItemText primary="Kontrak" />
                            </ListItemButton>
                        </Tooltip>
                    </List>
                    <Divider />
                </Drawer>
                <Box component="main" sx={{ flexGrow: 1 }}>
                    <DrawerHeader />

                    {props.child}
                </Box>
            </Box>
        </>
    );
}

export default NavBd